import { render, staticRenderFns } from "./SignInOrGuestToggle.vue?vue&type=template&id=065bda1b"
import script from "./SignInOrGuestToggle.vue?vue&type=script&lang=js"
export * from "./SignInOrGuestToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports